import { Skeleton } from '@Components/ui-v2/skeleton';

const NavSidebarSkeleton = () => {
  return (
    <div className="space-y-4 px-3 py-3">
      {[0, 1].map((groupIdx) => (
        <div key={groupIdx} className="space-y-1">
          <div className="px-2 py-1">
            <Skeleton className="h-2.5 w-16 rounded bg-gray-200" />
          </div>
          {[0, 1, 2].map((itemIdx) => (
            <div key={itemIdx} className="flex flex-col items-start gap-1 px-2.5 py-1.5">
              <Skeleton className="h-3 rounded bg-gray-100" style={{ width: `${55 + itemIdx * 10}%` }} />
              <Skeleton className="h-2 w-10 rounded bg-gray-100" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default NavSidebarSkeleton;
